import React from 'react';

import { ReactComponent as WaterTank } from './water-tank.svg';

function FarmbotWaterTankIcon() {
  return <WaterTank width={18} />;
}

export default FarmbotWaterTankIcon;
